import jwtDecode, { type JwtPayload } from 'jwt-decode'

export const isTokenExpired = (token: string | JwtPayload) => {
  const payload =
    typeof token === 'string' ? jwtDecode<JwtPayload>(token) : token
  return Boolean(payload.exp && payload.exp < Date.now() / 1000)
}
